<template>
  <section>
    <div class="l-container" data-scroll-section>
      <CSectionTitle textColor="white">
        <template v-slot:titleEn>
          SPECIAL INTERVIEW
        </template>
        <template v-slot:titleJa>
          スペシャルインタビュー
        </template>
        <template v-slot:bg></template>
      </CSectionTitle>
    </div>
    <section data-scroll-section>
      <ContentsHead />
    </section>
    <section
      class="js-color-change"
      data-logo-color="color"
      data-scroll-section
    >
      <div class="lead">
        <div class="in">
          <p>
            OCEAN
            TRICO史上、"最強"のハードワックスとして登場したJET。10月に解禁されたビジュアルでは、いまもっとも勢いをもって活躍する3組のプロフェッショナルをモデルとして起用した。彼らは日々、ハードな環境と向き合いながら、“最強”であり続けている。その裏側では、絶え間なき努力や葛藤があったはずだ。このスペシャルインタビューでは、そういった彼らの内面に向き合いながら、彼らが“最強”であり続ける所以を紐解いていく。<br />
            <br />
            1組目は、2015年に動画投稿をスタートさせ、毎日動画投稿を続けることで、二人組動画クリエイターのトップに躍りでた水溜りボンド。登録者数が430万人を突破した彼らの活動はオンラインから飛び出し、現在ではラジオ番組やバラエティ番組など、あらゆる領域を開拓し続けている。<br />
            <br />
            そんな彼らも“最強”であり続けるために、カメラの回っていないところで、軒並みならない努力を重ねているはずだ。トミーとカンタはバックステージでどう動き、自身のマインドをいかにセットしているのか。ビジュアル解禁1ヶ月前の9月に彼らのスタジオを訪れ、話を聞いた。
          </p>
        </div>
      </div>
    </section>
    <Sentence :photoSrc="require(`@/assets/mizutamari/mizutamari-cut-01.jpg`)">
      <template v-slot:lead>
        OCEANは自分たちよりも<br />自分のこと知ってる
      </template>
      <p class="interviewer">
        ──まずは、今回のヴィジュアルをお二人にご覧いただきましょう。
      </p>

      <p>
        <span class="name">トミー</span>
        おー！ すげえー！
      </p>
      <p>
        <span class="name secondary">カンタ</span>
        まじでかっこいい。この状態で生まれてきたかった。（笑）
      </p>

      <p class="interviewer">
        ──普段のお二人のイメージとは変わったスタイリングになったと思います。当日はOCEAN
        TOKYOの代表である高木琢也と三科光平がヘアセットを担当していましたが、実際に現場へ挑まれてみて、いかがでしたか？
      </p>

      <p>
        <span class="name">トミー</span>
        現場で改めて思ったんですけど、僕は髪型は外ハネがトレードマークとして決まっているので、もはや自分で自分を客観視できなくなってると思うんです。でも俯瞰した目線で「この髪型がかっこいい」って提案し、固定概念を崩していくところにOCEANらしさを感じました。
      </p>
      <p>
        <span class="name secondary">カンタ</span>
        僕もトミーのスタイリングを見た時に「おお！」ってびっくりしました。でも素直に納得もしましたね。その人の顔立ちや印象から、似合うスタイルを想像できているんだろうなって。自分たちよりも自分のこと知ってるみたいなもんだよね。
      </p>
      <p>
        <span class="name">トミー</span>
        わかる。僕もコンビでの見え方をすごく気にするので、相方がどういう髪型になるかわかんない状態で、自分の髪型をここまで崩すことは、基本的にオッケーしないんです。でも「OCEANだから」っていう気持ちもあって、信頼できたんですよね。<br />
        そもそも今回新商品が出ると聞いて「もっと貪欲に、もっと広げようとしてるんだな」って実感しました。こういった形で「一緒にやろう」って言ってもらえるのは、自分たちの姿勢が選ばれた気がして嬉しかったです。
      </p>
    </Sentence>

    <Sentence
      direction="left"
      :photoSrc="require(`@/assets/mizutamari/mizutamari-cut-02.jpg`)"
    >
      <template v-slot:lead>
        もう軸さえブレなければ<br />なんでも変化させるし、<br />どのリスクでも負う
      </template>
      <p class="interviewer">
        ──「変化」という点、お二人は昨年末にシェアハウスを解消し、直近では「毎日投稿」をやめる、という宣言もされていました。そういった自分たちの変化を、どう決断していくのかがすごく気になりました。ある意味、今までの考えを全部捨てるような怖さがあるのかな、と……。
      </p>

      <p>
        <span class="name">トミー</span>
        どちらかっていうと「変えれなくなっちゃうのが一番怖い」という気持ちで動いています。だから「それやるの怖くない？」みたいな話は相方としたことがないです。<br />
        <br />
        僕らは今までも「YouTuberはこうあるべき」みたいなものを本当にめちゃくちゃ壊してきたと思うんです。例えば、YouTuberとしてお金を取るイベントを開催することもそうですし、YouTuberでラジオやテレビの冠を持つ事もそう。前例がほとんどなかったと思うんですけど、それにも挑戦しています。<br />
        <br />
        結局「水溜りボンド」っていうコンビにとって一番いい選択肢を、いかに固定概念にとらわれず選べるか、で動いてるんですよね。
      </p>
      <p>
        <span class="name secondary">カンタ</span>
        あと、僕らは今YouTubeのトップを走ってる人たちに比べると、ちょっと後発組なんです。一番手の人たちは自分たちよりも先にいろんな事に挑戦して、自分たちの可能性をたくさん見せていった。僕らも「水溜りボンドって挑戦した時に面白いよね」っていうイメージがつくようになったら、もう一生楽しめると思ったんです。だからそうやって攻め気に動いていけるんだと思います。
      </p>
      <p>
        <span class="name">トミー</span>
        二人で仲良く動画撮ってるイメージがあるので、保守的なイメージはつきやすいと思ってます。でも実はめちゃくちゃ攻め気。変化に変化を重ね、もう軸さえブレなければなんでも変えるし、どんなリスクでも負うっていう考え方です。
      </p>

      <p class="interviewer">
        ──では、水溜りボンドが攻め気になる時の武器はなんだと思いますか？
      </p>
      <p>
        <span class="name">トミー</span>
        本当にめちゃくちゃ努力して、これ以上頑張れないし考えられない……っていうレベルまでやることです。これでダメだったらそもそも俺らに才能が足りなかったなと。そう思えるぐらいまでやる。僕らもたくさんミスってきたし、ボツになった動画はいくらでもあります。ただ努力のやり方を知っている人間になれば、何かでは評価されるようになるとは思います。
      </p>

      <p class="interviewer">
        ──その頑張る・努力するっていうのはYouTubeの世界だと「企画を考え抜く」っていうことになりますか？
      </p>
      <p>
        <span class="name secondary">カンタ</span>
        全力で楽しむための準備をすることだと思ってます。僕らのコンビは「２人で面白いことがしたい」っていう思いから始まってるんで、楽しくなきゃやってられない。じゃあ、楽しむためにはどうすればいい？
        って考える時、一生懸命準備して、作業するんです。全然寝れてない中で、今日も泥団子作ることだってあります。
      </p>
    </Sentence>

    <Sentence :photoSrc="require(`@/assets/mizutamari/mizutamari-cut-03.jpg`)">
      <template v-slot:lead>
        『あ、今日はいつもの<br />雰囲気とはちげえぞ』って<br />一瞬でわかるんです
      </template>
      <p class="interviewer">
        ──お二人は髪型や服装などのビジュアル面で「水溜りボンド」というコンビのブランドみたいなものを意識することはありますか？
      </p>

      <p>
        <span class="name secondary">カンタ</span>
        そんなにないよね？
      </p>

      <p>
        <span class="name">トミー</span>
        自分たちらしさを失わないように、という程度です。「自分がやりたい髪型であるか」っていうのはありますけどね。
      </p>

      <p>
        <span class="name secondary">カンタ</span>
        僕も、なんとなく自分が納得いってるものを選ぶようにはしてますね。「ブランドだったらここが良い」っていうのがあった時に、思い入れが確実にあるようにしてる。OCEANは凄い思い入れがあるので、大好きなワックスになってるなって思います。
      </p>

      <p>
        <span class="name">トミー</span>
        それこそ僕らはずっとイベントで使ってるのもOCEANのワックスとスプレーだしね。普段髪切ってるのもOCEAN。取材があったり、イベントがあったり、テレビに出たり雑誌の撮影だったりする時は、本当にOCEANのワックスとスプレーを使ってます。本当に崩れなくて、めっちゃキマるんですよね。
      </p>

      <p>
        <span class="name secondary">カンタ</span>
        ワックスはそんなつけるタイプじゃなかったんですけど、実際につけた時に「こんなできるの？」みたいに驚いたのを覚えています。ただ普段の動画だと、僕らのことを皆さん凄い知ってると思うからちょっと恥ずかしい（笑）。
      </p>

      <p>
        <span class="name">トミー</span>
        逆にこういう撮影の後は落とさないでそのままYouTubeに出ますね。だから髪が決まってる時は「なんかあったんかな今日」みたいになりますね。
      </p>

      <p class="interviewer">
        ──お二人は、なぜOCEANに通い続けるのでしょう？
      </p>

      <p>
        <span class="name secondary">カンタ</span>
        昔は髪とかも気にしてなくて、三科さんに切っていただく前も半信半疑だったんです。でもいざ切ってもらったら「これはもう全員切ってもらうべき」みたいな。その道を極めるってそういう事なんだなって思ったんです。<br />
        こうやってヘアサロンでも、OCEAN行った人が全く違う自分に出会えるんじゃないかなって思います。自宅でも、OCEAN
        TRICOで髪をセットした瞬間、「あ、今日はいつもの雰囲気とはちげえぞ」って一瞬でわかるんですよね。ホント魔法のワックスです。
      </p>

      <p>
        <span class="name">トミー</span>
        OCEANで髪を切るのは、一種その髪切りに行くっていう娯楽とか普通にそういうものではなく、OCEANに行くっていう職業体験みたいな気がしてるくらいですね。その姿勢とか会社のやり方とか、一人一人のプロ意識が僕らにとって刺さるものがすごいあって、毎回三科さんに髪切ってもらうのが普通に嬉しいし、三科さんと話すのが楽しみなんですよね。<br />
        <br />
        OCEANの姿勢のファンで。新しいものをやるにはどうすべきかを体現している会社なので、その会社の取り組みに参加できたのは嬉しかったです。今回、開拓する瞬間に立ち会えてる感じがして光栄です。
      </p>
    </Sentence>

    <Sentence
      direction="left"
      :photoSrc="require(`@/assets/mizutamari/mizutamari-cut-04.jpg`)"
    >
      <template v-slot:lead>
        自分たちが想像できない<br />ところで遊んでいくのが<br />“最強”なのかなって<br
          class="sp"
        />思います
      </template>
      <p class="interviewer">
        ──今回JETのキャッチコピーである「最強になれよ」にちなみ、２人が目指す「最強」の状態を教えてください。
      </p>

      <p>
        <span class="name secondary">カンタ</span>
        まだYouTuberがやってないことを切り拓いていくことに、視聴者も魅力を感じてくれたりする。それを維持するには、自由であるべきだなと思います。幅を広げるほど、昔だったら出来なかったことをどんどん実現できる。そうやって自分たちが想像できないところで遊んでいくのが最強なのかなって思いますね。
      </p>
      <p>
        <span class="name">トミー</span>
        水溜りボンドっていう２人組のコンビが最も愛される、最も自分たちのやりたいことを世の中の人たちに伝えることができるようになりたいと思って活動しています。そのスタンスを続けていったら最強になれるはず。
      </p>
      <p class="interviewer">
        ──確かに、２人がずっと続けられていくことが強さなんだと思いました。来年以降は特に「毎日投稿」という縛りがなくなる中で、できる企画の幅もさらに広がると思うのですが、何か直近で挑戦したいことや目標はありますか？
      </p>

      <p>
        <span class="name secondary">カンタ</span>
        今はありえないくらい色んな経験を日々していってるんで、自分たちの感情がスレていくんですよね。そうなるとずっと楽しみ続けるものを見つけることが超難しくなるので、日々楽しみ続ける努力を続けていくこと。それが目標です。
      </p>
      <p>
        <span class="name">トミー</span>
        僕も自分がやりたいと思うことや、相方とやりたいなって思うことを探すのが日々の目標になってます。あとは、視聴者と一緒に見たい景色を探すこと。実現するのはもう僕らの努力次第だと思います。
      </p>
    </Sentence>
    <section data-scroll-section>
      <div class="image-cut">
        <div class="image-cut__in image-fadeIn lazyload">
          <picture>
            <source
              class="lazyload"
              media="(max-width: 749px)"
              :data-srcset="
                require('@/assets/mizutamari/mizutamari-cut-05-sp.jpg')
              "
            />
            <source
              class="lazyload"
              media="(min-width: 750px)"
              :data-srcset="
                require('@/assets/mizutamari/mizutamari-cut-05.jpg')
              "
            />
            <img
              data-scroll
              data-scroll-speed="1.2"
              class="lazyload"
              :data-src="require('@/assets/mizutamari/mizutamari-cut-05.jpg')"
              alt=""
            />
          </picture>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import 'lazysizes'

import ContentsHead from '@/components/interview/ContentsHead.vue'
import Sentence from '@/components/interview/Sentence.vue'
import CSectionTitle from '@/components/C-SectionTitle.vue'

export default { components: { ContentsHead, Sentence, CSectionTitle } }
</script>

<style lang="scss" scoped>
.lead {
  background: #fff;
  transform: skewY(-6deg);

  .in {
    transform: skewY(6deg);
    p {
      color: var(--main-color);
      width: 100rem;
      margin: 0 auto;
      text-align: left;
      font-size: 2rem;
      font-weight: 700;
      padding: 10rem 0;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 100%;
        font-size: 1.6rem;
        padding: 6rem 2rem;
      }
    }
  }
}
.image-cut {
  position: relative;
  transform: skewY(-6deg);
  height: calc(80rem - 20rem);
  overflow: hidden;
  @media screen and (max-width: $breakpoint-mobile) {
    height: calc(60rem - 30rem);
  }
  &__in {
    position: relative;
    top: -10rem;
    height: 100rem;
    transform: translate(0px, -9rem) skewY(6deg);
    @media screen and (max-width: $breakpoint-mobile) {
      height: 42rem;
      top: 0;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
